import { useContext } from 'react';
import { Formik } from 'formik';
import { Container } from '@mui/material';
import { CircleLoader } from 'components';
import { CustomerUserForm } from './components';
import { userSchema, customerUserContext } from './CustomerUserContext';

let Users = () => {
    let service = useContext(customerUserContext);

    return (
        <Container>
            <Formik
                enableReinitialize={true}
                initialValues={service.user}
                validationSchema={userSchema}
                onSubmit={(values, action) => {
                    service.saveUser(values);
                    action.setSubmitting(false);;
                }}
            >
                {formProps =>
                    <>
                        {service.isLoading && <CircleLoader />}
                        {service.isLoading === false && <CustomerUserForm formProps={formProps} />}
                    </>
                }
            </Formik>
        </Container>
    )
}

export default Users;